<script setup lang="ts">
import { computed } from 'vue'
import BasePeriodicBanner from './BasePeriodicBanner.vue'

export type BannerVariant = 'BOGO' | 'BOGX' | 'discount' | 'cashback' | 'IWD' | 'STP'

const props = defineProps<{
  variant: BannerVariant
  name?: string
  countdown: number
}>()

const backgroundClass = computed(() => {
  const backgroundMap: Record<BannerVariant, string> = {
    'BOGO': 'default-BOGO-background',
    'BOGX': 'default-BOGX-background',
    'discount': 'default-discount-background',
    'cashback': 'default-cashback-background',
    'IWD': 'IWD-background',
    'STP': 'STP-banner-background',
  }
  return backgroundMap[props.variant]
})

const textClass = computed(() => {
  const textMap: Record<BannerVariant, string> = {
    'BOGO': 'text-black white-stroke',
    'BOGX': 'text-black white-stroke',
    'discount': 'font-[800] default-discount-text px-0.5',
    'cashback': 'default-cashback-purple-stroke default-cashback-background',
    'IWD': 'font-[800] IWD-text px-0.5',
    'STP': 'font-[800] STP-text px-0.5',
  }
  return textMap[props.variant]
})

const marginLeft = computed(() => {
  return props.variant === 'cashback' ? '-ml-[calc(50%-140px)]' : undefined
})
</script>

<template>
  <BasePeriodicBanner
    :name="name"
    :countdown="countdown"
    :background-class="backgroundClass"
    :text-class="textClass"
    :margin-left="marginLeft"
  >
    <template
      v-if="variant === 'cashback'"
      #icon
    >
      <img
        src="@/assets/images/gifs/telegram-star.gif"
        class="size-6"
      >
    </template>
  </BasePeriodicBanner>
</template>
